module.exports = __webpack_public_path__ + "static/media/system-design.f5c82bf1.svg";